import Instance from '../../../../Axios';

// New Actions for the app

const GetItensLimpeza = () => async (dispatch) => {
  await Instance()
    .get(`/backend/checklist/itens`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_ITENS_LIMPEZA', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetItensLimpeza;
